export default __webpack_public_path__ + "static/media/curt__O8A9877_final.9b84fd3b.jpg";